<script setup lang="ts">
  import { computed, watchEffect } from "vue";
  import { Text, IconArrowLeft } from "@ui-kit";
  import { StatusBar, TopBar } from "@src/components";
  import { useLazyProductsLoad } from "@src/api";
  import { Image } from "../Image";

  const { productId } = defineProps<{ productId?: string }>();
  const emit = defineEmits<{ "click:back": [value: void] }>();

  const { execute: loadProduct, data } = useLazyProductsLoad();

  const product = computed(() => data?.value?.items[0]);

  watchEffect(() => {
    if (productId) {
      loadProduct({ item_id: [productId] });
    }
  });
</script>

<template>
  <div class="product-short-card">
    <div class="product-short-card__content">
      <div class="product-short-card__img">
        <Image :url="product?.image_url" />
      </div>
      <div class="product-short-card__blur">
        <StatusBar />
        <TopBar :title="product?.title || ''" @click:left="emit('click:back')">
          <template #left>
            <IconArrowLeft />
          </template>
        </TopBar>
      </div>
      <div class="product-short-card__info product-short-card__blur">
        <div class="product-short-card__details">
          <Text font="body-medium-18" data-testid="product-short-card-article">{{ product?.article }}</Text>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .product-short-card {
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: var(--sf-base-background-secondary);
  }

  .product-short-card__content {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
  }

  .product-short-card__img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .product-short-card__img img {
    width: 100%;
  }

  .product-short-card__info {
    display: flex;
    justify-content: space-between;
    padding: 12px 16px 16px;
    margin-top: auto;
    align-items: flex-end;
  }

  .product-short-card__details {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .product-short-card__blur {
    backdrop-filter: blur(7px);
  }
</style>
